import {memo} from 'react';

import {Map as GoogleMap} from '@vis.gl/react-google-maps';

import {SupportedQueryParamsType} from '~/shared/router/supportedQueryParams';
import {serializeCoordinate} from '~/shared/components/Maps/utils';

import Markers from './Markers';
import RecenterButton from './RecenterButton';
import {Coordinate} from './types';

type MapViewProps = {
  defaultCenter: Coordinate;
  defaultZoom: number;
  onCenterChanged?: ({detail: {center, zoom}}: any) => void;
  businessLocation?: Coordinate | null;
  onBusinessMarkerClick?: () => void;
  userLocation?: Coordinate | null;
  onUserMarkerClick?: () => void;
  courierLocation?: Coordinate | null;
  dotsOfLastRoute?: Coordinate[];
  onRecenter?: () => void;
  showCenterButton?: boolean;
  debug?: SupportedQueryParamsType['debug'];
};

const MapView = ({
  defaultCenter,
  defaultZoom,
  onCenterChanged,
  businessLocation,
  onBusinessMarkerClick,
  userLocation,
  onUserMarkerClick,
  courierLocation,
  dotsOfLastRoute,
  onRecenter,
  showCenterButton = true,
  debug,
}: MapViewProps) => {
  return (
    <GoogleMap
      mapId="749a0ba1260fd863ec445cda"
      defaultCenter={serializeCoordinate(defaultCenter)}
      defaultZoom={defaultZoom}
      mapTypeControl={false}
      fullscreenControl={false}
      clickableIcons={false}
      onCenterChanged={onCenterChanged}
      maxZoom={19}
    >
      <Markers
        businessLocation={businessLocation}
        onBusinessMarkerClick={onBusinessMarkerClick}
        userLocation={userLocation}
        onUserMarkerClick={onUserMarkerClick}
        courierLocation={courierLocation}
        dotsOfLastRoute={dotsOfLastRoute}
        centerLocation={defaultCenter}
        debug={debug}
      />
      {!!onRecenter && showCenterButton && <RecenterButton onRecenter={onRecenter} />}
    </GoogleMap>
  );
};

export default memo(MapView);
